
import mp3 from './media/mp3';

export default {
  name: 'can-focus-audio-without-controls',
  element: 'audio',
  mutate: function mutate(element) {
    try {
      // invalid media file can trigger warning in console, data-uri to prevent HTTP request
      element.setAttribute('src', mp3);
    } catch (e) {
      // IE9 may throw "Error: Not implemented"
    }
  }
};
//# sourceMappingURL=focus-audio-without-controls.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ally.js/esm/supports/focus-audio-without-controls.js
// module id = 177
// module chunks = 0 1